import { Helmet } from "react-helmet-async";
import { Wrench, Phone, Mail, Clock } from "lucide-react";
import btoLogo from "@/assets/b-to-logo.webp";

const Maintenance = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 text-center">
      <Helmet>
        <title>Site en maintenance | FAST CABS</title>
        <meta name="description" content="FAST CABS est momentanément en maintenance. Revenez très bientôt." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Site en maintenance | FAST CABS" />
        <meta property="og:description" content="FAST CABS est momentanément en maintenance. Revenez très bientôt." />
      </Helmet>

      <div className="max-w-xl w-full">
        <img
          src="/logo-fastcabs.webp"
          alt="FAST CABS"
          width={180}
          height={72}
          className="mx-auto mb-10"
          loading="eager"
        />


        <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-8">
          <Wrench className="h-10 w-10 text-primary" aria-hidden="true" />
        </div>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
          Site en maintenance
        </h1>
        <p className="text-muted-foreground text-lg mb-10">
          Notre site est temporairement indisponible. Nous mettons tout en œuvre pour le rétablir dans les meilleurs délais.
        </p>

        <div className="border-t border-border pt-10 space-y-6">
          <p className="text-sm uppercase tracking-widest text-primary font-semibold">
            Contact d'urgence
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="tel:+33782858892"
              className="inline-flex items-center gap-2 text-foreground hover:text-primary transition-colors"
            >
              <Phone className="h-5 w-5 text-primary" />
              <span className="font-medium">07 82 85 88 92</span>
            </a>
            <a
              href="mailto:contact@fastcabs.fr"
              className="inline-flex items-center gap-2 text-foreground hover:text-primary transition-colors"
            >
              <Mail className="h-5 w-5 text-primary" />
              <span className="font-medium">contact@fastcabs.fr</span>
            </a>
          </div>

          <p className="inline-flex items-center gap-2 text-muted-foreground text-sm">
            <Clock className="h-4 w-4" />
            Disponible 24h/24, 7j/7
          </p>
        </div>
      </div>

      <div className="mt-auto py-6">
        <a
          href="https://b-to.io/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-muted-foreground transition-colors hover:text-foreground"
          aria-label="Site réalisé par B-to"
        >
          Site réalisé par
          <img
            src={btoLogo}
            alt="B-to - Agence digitale"
            className="h-7 w-auto"
            width="70"
            height="28"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};

export default Maintenance;
